// Chave do CT-e / Manifesto pelo código de barras (0.17.0): o botão "Ler o
// código de barras" (foto do código de barras ou do QR code do DACTE ou do
// DAMDFE) e a chave colada ou digitada no campo (44 números) viram o número,
// com uma linha dizendo o que foi lido.
import { lerCodigosDaFoto } from '../lib/codigo-de-barras.js';
import { lerChave, textoDaChave } from '../lib/cte.js';
import { h, icone } from '../lib/dom.js';
import { avisar } from './componentes.js';

//   campoNumero: o <input> do número · aoLer(chave): o que mais fazer (ex.: escolher o cliente)
//   nomeDoEmitente(cnpj): o nome cadastrado, se houver
export function leitorDaChave({ campoNumero, aoLer = () => {}, nomeDoEmitente = () => null }) {
  const info = h('p', { class: 'dica chave-lida', hidden: true, 'aria-live': 'polite' });
  const aplicar = (c) => {
    campoNumero.value = c.numero;
    info.textContent = `Lido: ${textoDaChave(c, { nomeDoEmitente: nomeDoEmitente(c.cnpj) })}.`;
    info.hidden = false;
    aoLer(c);
  };
  // A chave colada ou digitada no campo
  campoNumero.addEventListener('input', () => {
    const c = campoNumero.value.replace(/\D/g, '').length >= 44 ? lerChave(campoNumero.value) : null;
    if (c) aplicar(c);
  });

  const entrada = h('input', { type: 'file', accept: 'image/*', capture: 'environment', hidden: true, tabindex: '-1', class: 'foto-da-chave' });
  const texto = 'Ler o código de barras';
  const rotulo = h('span', null, texto);
  const botao = h('button', { class: 'botao secundario cheio ler-chave', type: 'button', onClick: () => entrada.click() },
    icone('camera', { tamanho: 20 }), rotulo);
  entrada.addEventListener('change', async () => {
    const arquivo = entrada.files?.[0];
    entrada.value = '';
    if (!arquivo) return;
    botao.disabled = true;
    rotulo.textContent = 'Lendo o código…';
    try {
      const codigos = await lerCodigosDaFoto(arquivo);
      const c = codigos.map(lerChave).find(Boolean);
      if (c) {
        aplicar(c);
        avisar(`${c.tipo} nº ${c.numero} lido.`);
      } else if (codigos.length > 0) {
        avisar('O código lido não é a chave de um CT-e ou de um Manifesto. Tire a foto do código de barras de cima do DACTE.', 'erro');
      } else {
        avisar('Não achei o código de barras na foto. Tire mais perto, com o código inteiro, reto e com luz, ou digite o número.', 'erro');
      }
    } catch (erro) {
      console.warn('Leitura do código de barras', erro);
      avisar('Não deu para ler o código agora (a primeira vez precisa de internet). Digite o número.', 'erro');
    } finally {
      botao.disabled = false;
      rotulo.textContent = texto;
    }
  });
  return h('div', { class: 'leitor-da-chave' }, botao, entrada, info);
}
